import { useState, useCallback } from '@wordpress/element';

/* ─── dialog component ─── */
export const ConfirmDialog = ({ dialog, onConfirm, onCancel }) => {
    if (!dialog) return null;

    return (
        <div className="cpiw-confirm-overlay" role="dialog" aria-modal="true">
            <div className="cpiw-confirm">
                <div className="cpiw-confirm__icon">
                    {dialog.type === 'danger' ? '🗑' : '⚠'}
                </div>
                <h3 className="cpiw-confirm__title">{dialog.title || 'Are you sure?'}</h3>
                <p className="cpiw-confirm__msg">{dialog.message}</p>
                <div className="cpiw-confirm__actions">
                    <button className="cpiw-btn-secondary" onClick={onCancel}>
                        Cancel
                    </button>
                    <button
                        className={dialog.type === 'danger' ? 'cpiw-btn-danger-solid' : 'cpiw-btn'}
                        onClick={onConfirm}
                    >
                        {dialog.confirmLabel || 'Confirm'}
                    </button>
                </div>
            </div>
        </div>
    );
};

/* ─── hook ─── */
export const useConfirm = () => {
    const [dialog, setDialog]       = useState(null);
    const [resolver, setResolver]   = useState(null);

    const confirm = useCallback(({ title, message, confirmLabel = 'Delete', type = 'danger' }) => {
        return new Promise((resolve) => {
            setDialog({ title, message, confirmLabel, type });
            setResolver(() => resolve);
        });
    }, []);

    const handleConfirm = () => { setDialog(null); resolver && resolver(true);  };
    const handleCancel  = () => { setDialog(null); resolver && resolver(false); };

    return { dialog, confirm, handleConfirm, handleCancel };
};
